<template>
  <div>
    <Banner />
    <DataService />
    <Business />
    <Scene />
    <OwFooter />
  </div>
</template>
<script>
import Banner from "./components/banner";
import DataService from "./components/dataService";
import Business from "./components/business";
import Scene from "./components/scene";
import OwFooter from "@/components/ow-footer";
export default {
  components: {
    Banner,
    DataService,
    Business,
    Scene,
    OwFooter
  },
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped></style>
